var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-overlay',{attrs:{"show":_vm.show,"variant":_vm.variant,"opacity":_vm.opacity,"blur":_vm.blur,"rounded":"lg","spinner-variant":"primary"}},[_c('company-payment-show',{attrs:{"data":_vm.payments,"slug":this.$route.params.slug,"role":_vm.role,"back":'/company/payments'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }